import Cookies from "js-cookie"
import type { AuthSession } from "@/pages/login/domain/entities/auth"

const EMAIL_KEY = "so-fe-auth-email"
const USER_ID_KEY = "so-fe-user-id"
const ACCESS_TOKEN_COOKIE = "accessToken"
const REFRESH_TOKEN_COOKIE = "refreshToken"
const COOKIE_OPTS: Cookies.CookieAttributes = { path: "/", sameSite: "Strict" }

export const readStoredSession = (): AuthSession | null => {
  const accessToken = Cookies.get(ACCESS_TOKEN_COOKIE)
  const refreshToken = Cookies.get(REFRESH_TOKEN_COOKIE)
  if (!accessToken || !refreshToken) return null
  const email = localStorage.getItem(EMAIL_KEY) ?? ""
  const userId = localStorage.getItem(USER_ID_KEY) ?? undefined
  return { accessToken, refreshToken, email, userId }
}

export const writeStoredSession = (session: AuthSession) => {
  Cookies.set(ACCESS_TOKEN_COOKIE, session.accessToken, COOKIE_OPTS)
  Cookies.set(REFRESH_TOKEN_COOKIE, session.refreshToken, COOKIE_OPTS)
  localStorage.setItem(EMAIL_KEY, session.email)
  if (session.userId) {
    localStorage.setItem(USER_ID_KEY, session.userId)
  } else {
    localStorage.removeItem(USER_ID_KEY)
  }
}

export const clearStoredSession = () => {
  Cookies.remove(ACCESS_TOKEN_COOKIE, { path: "/" })
  Cookies.remove(REFRESH_TOKEN_COOKIE, { path: "/" })
  localStorage.removeItem(EMAIL_KEY)
  localStorage.removeItem(USER_ID_KEY)
}
